import { useState, useEffect, useRef } from "react";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = async () => {
    try {
      const res = await api.get("/notifications");
      setData(res.data);
    } catch (e) {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread > 0) {
      await api.patch("/notifications/read").catch(() => {});
      setData((d) => ({ ...d, unread: 0 }));
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} className="relative p-2 text-primary hover:text-accent" data-testid="notification-bell" aria-label="Notifications">
        <Bell className="h-6 w-6" />
        {data.unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-5 w-5 rounded-full bg-accent text-[11px] font-bold text-white flex items-center justify-center" data-testid="notification-count">
            {data.unread > 9 ? "9+" : data.unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[90vw] bg-white rounded-2xl soft-shadow border border-gray-100 overflow-hidden z-50" data-testid="notification-panel">
          <div className="px-4 py-3 border-b border-gray-100 font-head font-bold text-primary">Notifications</div>
          <div className="max-h-96 overflow-y-auto">
            {data.items.length === 0 ? (
              <p className="px-4 py-6 text-sm text-muted-foreground text-center">Aucune notification</p>
            ) : (
              data.items.map((n) => (
                <div key={n.id} className={`px-4 py-3 border-b border-gray-50 text-sm ${n.read ? "text-muted-foreground" : "text-primary font-medium bg-accent/5"}`}>
                  {n.text}
                  <div className="text-[11px] text-muted-foreground mt-1">
                    {new Date(n.created_at).toLocaleString("fr-FR")}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
